
export default function SystemCorrectionGhostTopBar({handleClose}) {
    // Used in FlashCorrectionScreen to display a transparent top bar
    // used to close current modal

    // BUILD
    return (
        <div className={"cursor-pointer w-full h-[64px] lg:h-[72px] min-h-[64px] lg:min-h-[72px]"}
             onClick={handleClose}>
        </div>
    );
}